import React from 'react';
import ReactDOM from 'react-dom/client'; // <-- MUDANÇA IMPORTANTE
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Register Chart.js components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

// 1. Obtenha o container do DOM
const container = document.getElementById('root');

// 2. Crie a "root"
const root = ReactDOM.createRoot(container);

// 3. Renderize seu App na "root"
// Adicionei o <React.StrictMode> que é uma boa prática
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorker.unregister();
